import Number from "./components/Number";

export default {
	Number,
};
